import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { DeliveryManCrudService } from 'src/app/shared/services/delivery-man-crud.service';
import { DeliveryMan } from 'src/app/shared/interfaces/delivery-man';

@Component({
  selector: 'app-delivery-men',
  templateUrl: './delivery-men.component.html',
  styleUrls: ['./delivery-men.component.scss']
})
export class DeliveryMenComponent implements OnInit {

  deliveryMen: DeliveryMan[];
  deliveryMan: DeliveryMan;
  selectedDeliveryMen: DeliveryMan[] = [];

  deliveryManDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private deliveryManService : DeliveryManCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Delivery men'}
    ];

    this.deliveryMen = [];
    this.deliveryMan = { } as DeliveryMan ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.deliveryManService.getDeliveryMansList(); 
    s.snapshotChanges().subscribe(data => {
      this.deliveryMen = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : DeliveryMan = jsonItem as DeliveryMan;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.deliveryMen.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'tags');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');


    // Exports
    //this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
    this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};

    } );
  }

  dataState() {     
    this.deliveryManService.getDeliveryMansList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    console.log( 'includesCol ', c);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.deliveryMen);
            doc.save('deliveryMen.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.deliveryMen);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "deliveryMen");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedDeliveryMen, 'deliveryMen', exportCols);
    //this.exportService.exportToCsv(this.deliveryMen, 'deliveryMen', ['title', 'description', '$key', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.deliveryMan = {} as DeliveryMan;
    this.submitted = false;
    this.deliveryManDialog = true;
  }

  deleteSelectedDeliveryMans() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected deliveryMen?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.deliveryMen = this.deliveryMen.filter(val => !this.selectedDeliveryMen.includes(val));
          
          this.selectedDeliveryMen.forEach( dm => this.deliveryManService.deleteDeliveryMan(dm.$key));
          this.selectedDeliveryMen = [];
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Delivery men deleted', life: 3000});
        }
    });
  }

  editDeliveryMan(deliveryMan: DeliveryMan) {
    this.deliveryMan = {...deliveryMan};
    this.deliveryManDialog = true;
  }

  deleteDeliveryMan(deliveryMan: DeliveryMan) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + deliveryMan.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.deliveryMen = this.deliveryMen.filter(val => val.$key !== deliveryMan.$key);
            this.deliveryMan = {} as DeliveryMan;
            this.deliveryManService.deleteDeliveryMan(deliveryMan.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'DeliveryMan Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.deliveryManDialog = false;
    this.submitted = false;
  }

  saveDeliveryMan() {
    this.submitted = true;
    if ( this.deliveryMan.name.trim() ) {
      if (this.deliveryMan.$key) {
          this.deliveryMen[this.findIndexById(this.deliveryMan.$key)] = this.deliveryMan;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'DeliveryMan Updated', life: 3000});
          this.deliveryManService.updateDeliveryMan(this.deliveryMan);
        } else {
          this.deliveryMan.position = this.deliveryMen.length;
          this.deliveryManService.addDeliveryMan(this.deliveryMan);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'DeliveryMan Created', life: 3000});
      this.deliveryMen = [...this.deliveryMen];
    }

    this.deliveryManDialog = false;
    this.deliveryMan = { } as DeliveryMan;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.deliveryMen.length; i++) {
        if (this.deliveryMen[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeDeliveryMan(deliveryMan : DeliveryMan) {
    this.deliveryManService.updateDeliveryMan(deliveryMan);
  }

  // Ordering
  completePosition(deliveryMan : DeliveryMan) {
    if ( this.newPosition > -1 ) {
        deliveryMan.position = this.newPosition;
        deliveryMan = this.checkPositionLimits(deliveryMan);
        this.reorderElements(deliveryMan);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.deliveryMen.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.deliveryMen.length - 1 - event.dropIndex;
    const deliveryManToMove = this.deliveryMen[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.deliveryMen[index] = this.deliveryMen[index+1];
        this.deliveryMen[index].position = index;
        this.deliveryManService.updateDeliveryMan(this.deliveryMen[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.deliveryMen[index] = this.deliveryMen[index-1];
        this.deliveryMen[index].position = index;
        this.deliveryManService.updateDeliveryMan(this.deliveryMen[index]);
      }
    } 
    this.deliveryMen[endIndex] = deliveryManToMove;
    this.deliveryMen[endIndex].position = endIndex;
    this.deliveryManService.updateDeliveryMan(this.deliveryMen[endIndex]);
  }

  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.deliveryMen.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, deliveryMan: DeliveryMan) {
    if (deliveryMan.position != null && deliveryMan.position > -1) {
      this.previousPosition = deliveryMan.position;
      this.newPosition = event;
    }
  }

  checkPositionLimits(deliveryMan: DeliveryMan) {
    if (!deliveryMan.position) {
      return this.deliveryMan;
    }
    if (deliveryMan.position < 0) {
      deliveryMan.position = 0;
      return deliveryMan;
    }
    if (deliveryMan.position > this.deliveryMen.length) {
      deliveryMan.position = this.deliveryMen.length - 1;
      return deliveryMan;
    }
    return deliveryMan;
  }

  async reorderElements(deliveryMan: DeliveryMan) {
    this.newPosition = this.newPosition  > this.deliveryMen.length ? this.deliveryMen.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === deliveryMan.position ) {
      return;
    }
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const deliveryManToMove = this.deliveryMen[startIndex];
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        this.deliveryMen[index] = this.deliveryMen[index+1];
        this.deliveryMen[index].position = index;
        this.deliveryManService.updateDeliveryMan(this.deliveryMen[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.deliveryMen[index] = this.deliveryMen[index-1];
        this.deliveryMen[index].position = index;
        this.deliveryManService.updateDeliveryMan(this.deliveryMen[index]);
      }
    } 
    this.deliveryMen[endIndex] = deliveryManToMove;
    this.deliveryMen[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.deliveryManService.updateDeliveryMan(this.deliveryMen[endIndex]);
    
  }
}
